import cookie from 'react-cookies'

export const getUser = () => {
	return cookie.load('user')
}
